import React from 'react'
import Back from '../common/Back'
import CoursesCard from './CoursesCard'

const Courses = () => {
    return (
        <>
            <Back title='Courses'/>
            <CoursesCard />
        </>
    )
}

export default Courses
